import { Injectable, signal, Signal } from '@angular/core';
import { CarrierListStateLOBsModel } from 'api-clients/agency-admin-api-client';
import { BehaviorSubject } from 'rxjs';
import { State } from 'src/shared/account/models/state';
import { HttpBase } from 'src/shared/http-base/http-base';
@Injectable()
export class CarrierService extends HttpBase {
  private headerTitle = signal<string>('Manage Carriers');

  selectPreferredCarrierToggle = false;
  hasPreferredCarriers = new BehaviorSubject<boolean>(false);

  #carrierListStateLOBsModel: CarrierListStateLOBsModel[] = [];
  #ratingStates: State[] = [];

  set carriersStateLobs(carrierListStateLOBsModel: CarrierListStateLOBsModel[]) {
    this.#carrierListStateLOBsModel = carrierListStateLOBsModel;
  }

  get carriersStateLobs(): CarrierListStateLOBsModel[] {
    return this.#carrierListStateLOBsModel;
  }

  set ratingStates(ratingStates: State[]) {
    this.#ratingStates = ratingStates;
  }

  get ratingStates(): State[] {
    return this.#ratingStates;
  }

  setHeaderTitle(title: string): void {
    this.headerTitle.set(title);
  }

  getHeaderTitle(): Signal<string> {
    return this.headerTitle;
  }

}
